{
  "appTitle": "BACK OFFICE",
  "greetings": [
    "Hi! Good to see you again!",
    "Welcome back! Ready to dive in?",
    "Good to have you back!",
    "Hello! Let's get to work.",
    "Back again? Let's go!",
    "Great to see you. Let's check in."
  ],
  "email": "Email",
  "continue": "Continue",
  "password": "Password",
  "sign-in": "Sign In",
  "back": "Use a different email",
  "sso-redirecting": "Redirecting to SSO...",
  "or": "or",
  "passkey": {
    "signIn": "Sign in with passkey",
    "error": "Passkey sign-in failed. Please try again or use your password.",
    "unknownCredential": "This passkey isn't recognized. Please sign in with your password."
  },
  "mfa": {
    "label": "Authentication Code",
    "hint": "Enter the 6-digit code from your authenticator app.",
    "verify": "Verify",
    "invalidCode": "Incorrect code — please try again."
  },
  "changePassword": {
    "description": "Your password must be updated before you can continue.",
    "current": "Current password",
    "new": "New password",
    "confirm": "Confirm new password",
    "submit": "Update password",
    "mismatch": "New passwords don't match.",
    "wrongCurrent": "Current password is incorrect.",
    "error": "Couldn't update password. Please try again."
  },
  "errors": {
    "invalidCredentials": "Unable to Sign In, verify credentials and try again",
    "unauthorized": "Unable to Sign In, try again",
    "accountLocked": "Account is locked, try again later",
    "accessNotGranted": "Access to Back Office not granted",
    "ssoRequired": "This account uses single sign-on. Please sign in with SSO."
  }
}
